module.exports = __webpack_public_path__ + "img/edit-button-remark.d512c19d.svg";